import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xff5jwej98: FaireBrandEntity = {
  token: "b_xff5jwej98",
  type: "brand",
  name: "McKenzie’s Infinity LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/e3460623ab77e02fc31742071cc5bf2074286ad5fbf7337bdfb69ddebb1d3645.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5514d6221f3d3afd2dda8dbed7bb0139bc7f18b962e5d3c23efe390d277b59e9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e3460623ab77e02fc31742071cc5bf2074286ad5fbf7337bdfb69ddebb1d3645.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5514d6221f3d3afd2dda8dbed7bb0139bc7f18b962e5d3c23efe390d277b59e9.png",
  location: "Red bud , IL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 14,
  isInsider: true,
  description:
    "Welcome to McKenzie's Infinity LLC – Your Trusted Source for Apparel & Embroidery! Our commitment to excellence extends beyond our product offerings. We aim to create a seamless shopping experience for you, where exploring our diverse collection becomes an exciting journey. So, take your time and browse through our website, where you'll undoubtedly discover something you just have to have! We look forward to exceeding your expectations and helping you find that perfect item to cherish for years to come!\n\nBy placing a wholesale order with McKenzie’s Infinity LLC, buyer agrees:\n• Final Sale: All wholesale orders are final sale. No returns or refunds once received, except for errors caused by McKenzie’s Infinity LLC.\n• Labeling: FTC labeling applies at retail sale. Buyer is solely responsible for all labeling compliance.\n• Turnaround: Production times are stated at order and are estimates only. Shipping time is not included. Delays do not qualify for cancellation or refund.\n• Color Disclaimer: Garments are not pre-washed. Color bleed or dye transfer, including split/color-block garments, is normal and not a defect.\n• Variations: Minor variations are normal.\n• Claims: Claims must be submitted within 3 business days.\n• Liability: Liability is limited to the wholesale purchase price only.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:43.213Z",
    importedBy: "entity-db-cli",
  },
};
